// // src/Pages/HospitalServicesLedger/HospitalServicesLedger.jsx

// import React, { useState, useEffect } from 'react';
// import axiosInstance from '../../Services/axiosInstance';
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// const HospitalServicesLedger = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');

//   // ------------------------
//   // SERVICE SELECTION STATES
//   // ------------------------
//   const [showSelector, setShowSelector] = useState(false);
//   const [selectedServices, setSelectedServices] = useState([]); // saved selections
//   const [tempSelectedServices, setTempSelectedServices] = useState([]); // temporary selections

//   // ------------------------
//   // FILTER DATA BASED ON SELECTION
//   // ------------------------
//   const filteredData =
//     selectedServices.length === 0
//       ? data
//       : data.filter((item) => selectedServices.includes(item.name));

//   // ------------------------
//   // DOWNLOAD EXCEL
//   // ------------------------
//   const downloadExcel = () => {
//     if (!filteredData || filteredData.length === 0) return;

//     let totalPurchaseAmount = 0;
//     let totalQtySold = 0;
//     let totalSaleAmount = 0;
//     let totalProfitLoss = 0;

//     const exportData = filteredData.map((item) => {
//       const purchasedPrice = parseFloat(item.purchase_price) || 0;
//       const totalQty = Number(item.total_quantity_sold || 0);
//       const totalPurchase = purchasedPrice * totalQty;
//       const totalSale = Number(item.total_sale_amount || 0);
//       const profitLoss = totalSale - totalPurchase;

//       totalPurchaseAmount += totalPurchase;
//       totalQtySold += totalQty;
//       totalSaleAmount += totalSale;
//       totalProfitLoss += profitLoss;

//       return {
//         Name: item.name,
//         PurchasedPrice: purchasedPrice.toFixed(2),
//         TotalPurchaseAmount: totalPurchase.toFixed(2),
//         SalePrice: parseFloat(item.price).toFixed(2),
//         TotalQtySold: totalQty,
//         TotalSaleAmount: totalSale.toFixed(2),
//         TotalProfitLoss: profitLoss.toFixed(2),
//       };
//     });

//     // TOTAL ROW
//     exportData.push({
//       Name: 'TOTAL',
//       PurchasedPrice: '',
//       TotalPurchaseAmount: totalPurchaseAmount.toFixed(2),
//       SalePrice: '',
//       TotalQtySold: totalQtySold,
//       TotalSaleAmount: totalSaleAmount.toFixed(2),
//       TotalProfitLoss: totalProfitLoss.toFixed(2),
//     });

//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Services Ledger");

//     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
//     saveAs(blob, `HospitalServicesLedger.xlsx`);
//   };

//   // ------------------------
//   // FETCH DATA
//   // ------------------------
//   const fetchServiceData = async (start = '', end = '') => {
//     try {
//       setLoading(true);
//       const params = {};
//       if (start) params.startDate = start;
//       if (end) params.endDate = end;

//       const response = await axiosInstance.get('/dispenser-sales/medical-services', { params });
//       setData(response.data.data || []);
//       setError(null);
//     } catch (err) {
//       console.error('Fetch error:', err);
//       setError('Failed to load medical services data.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchServiceData(startDate, endDate);
//   }, [startDate, endDate]);

//   // ------------------------
//   // CALCULATE TOTALS FOR TABLE
//   // ------------------------
//   const totals = filteredData.reduce(
//     (acc, service) => {
//       const purchasedPrice = parseFloat(service.purchase_price) || 0;
//       const totalQtySold = Number(service.total_quantity_sold || 0);
//       const totalPurchaseAmount = purchasedPrice * totalQtySold;
//       const totalSaleAmount = Number(service.total_sale_amount || 0);
//       const totalProfitLoss = totalSaleAmount - totalPurchaseAmount;

//       acc.totalPurchaseAmount += totalPurchaseAmount;
//       acc.totalQtySold += totalQtySold;
//       acc.totalSaleAmount += totalSaleAmount;
//       acc.totalProfitLoss += totalProfitLoss;

//       return acc;
//     },
//     { totalPurchaseAmount: 0, totalQtySold: 0, totalSaleAmount: 0, totalProfitLoss: 0 }
//   );

//   if (loading) return <div className="p-4 text-center">Loading data...</div>;
//   if (error) return <div className="p-4 text-center text-red-600 font-semibold">{error}</div>;

//   return (
//     <div className="container mx-auto p-4">

//       <div className="flex justify-between items-center mb-4">
//         <h1 className="text-2xl font-bold">Hospital Services Ledger</h1>

//         {/* SELECT SERVICES BUTTON */}
//         <button
//           className="bg-blue-600 text-white px-4 py-2 rounded"
//           onClick={() => {
//             setTempSelectedServices(selectedServices); // store current selections
//             setShowSelector(true);
//           }}
//         >
//           Select Services
//         </button>
//       </div>

//       {/* SERVICE SELECTOR POPUP */}
//       {showSelector && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
//           <div className="bg-white p-6 w-96 rounded shadow-lg">
//             <h2 className="text-xl font-bold mb-3">Select Services</h2>

//             <div className="max-h-60 overflow-y-auto border p-2">
//               {data.map((item) => (
//                 <label key={item.id} className="flex items-center gap-2 py-1">
//                   <input
//                     type="checkbox"
//                     checked={tempSelectedServices.includes(item.name)}
//                     onChange={() => {
//                       if (tempSelectedServices.includes(item.name)) {
//                         setTempSelectedServices(tempSelectedServices.filter(s => s !== item.name));
//                       } else {
//                         setTempSelectedServices([...tempSelectedServices, item.name]);
//                       }
//                     }}
//                   />
//                   {item.name}
//                 </label>
//               ))}
//             </div>

//             <div className="mt-4 flex justify-end gap-3">
//               {/* CANCEL: discard selections */}
//               <button
//                 className="px-4 py-2 bg-gray-400 text-white rounded"
//                 onClick={() => {
//                   setSelectedServices([]); // reset selection
//                   setShowSelector(false);
//                 }}
//               >
//                 Cancel
//               </button>

//               {/* DONE: save selections */}
//               <button
//                 className="px-4 py-2 bg-blue-600 text-white rounded"
//                 onClick={() => {
//                   setSelectedServices(tempSelectedServices); // save selection
//                   setShowSelector(false);
//                 }}
//               >
//                 Done
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* DATE FILTER */}
//       <div className="flex gap-6 mb-6">
//         <div>
//           <label className="font-semibold text-gray-700">Start Date:</label>
//           <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)}
//             className="border-b-2 ml-2" />
//         </div>

//         <div>
//           <label className="font-semibold text-gray-700">End Date:</label>
//           <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)}
//             className="border-b-2 ml-2" />
//         </div>
//       </div>

//       {/* TABLE */}
//       {filteredData.length > 0 ? (
//         <div className="bg-white shadow-lg rounded overflow-hidden">
//           <div className="overflow-x-auto max-h-[500px] relative">
//             <table className="table-auto w-full text-sm">
//               <thead className="bg-gray-50">
//                 <tr>
//                   <th className="sticky top-0 px-3 py-2 bg-gray-50">Name</th>
//                   <th className="sticky top-0 px-3 py-2 bg-gray-50">Purchased Price</th>
//                   <th className="sticky top-0 px-3 py-2 bg-gray-50">Total Purchase Amount</th>
//                   <th className="sticky top-0 px-3 py-2 bg-gray-50">Sale (Price)</th>
//                   <th className="sticky top-0 px-3 py-2 bg-gray-50">Total Qty Sold</th>
//                   <th className="sticky top-0 px-3 py-2 bg-gray-50">Total Sale Amount</th>
//                   <th className="sticky top-0 px-3 py-2 bg-gray-50">Total Profit / Loss</th>
//                 </tr>
//               </thead>

//               <tbody className="divide-y">
//                 {filteredData.map((service) => {
//                   const purchasedPrice = parseFloat(service.purchase_price) || 0;
//                   const totalQtySold = Number(service.total_quantity_sold || 0);
//                   const totalPurchaseAmount = purchasedPrice * totalQtySold;
//                   const salePrice = parseFloat(service.price) || 0;
//                   const totalSaleAmount = Number(service.total_sale_amount || 0);
//                   const totalProfitLoss = totalSaleAmount - totalPurchaseAmount;

//                   return (
//                     <tr key={service.id}>
//                       <td className="px-3 py-2">{service.name}</td>
//                       <td className="px-3 py-2">Rs.{purchasedPrice.toFixed(2)}</td>
//                       <td className="px-3 py-2">Rs.{totalPurchaseAmount.toFixed(2)}</td>
//                       <td className="px-3 py-2">Rs.{salePrice.toFixed(2)}</td>
//                       <td className="px-3 py-2">{totalQtySold}</td>
//                       <td className="px-3 py-2">Rs.{totalSaleAmount.toFixed(2)}</td>
//                       <td className="px-3 py-2">Rs.{totalProfitLoss.toFixed(2)}</td>
//                     </tr>
//                   );
//                 })}

//                 {/* TOTAL ROW */}
//                 <tr className="bg-white font-bold sticky bottom-0">
//                   <td className="px-3 py-3">TOTAL</td>
//                   <td></td>
//                   <td className="px-3 py-3">Rs.{totals.totalPurchaseAmount.toFixed(2)}</td>
//                   <td></td>
//                   <td className="px-3 py-3">{totals.totalQtySold}</td>
//                   <td className="px-3 py-3">Rs.{totals.totalSaleAmount.toFixed(2)}</td>
//                   <td className="px-3 py-3">Rs.{totals.totalProfitLoss.toFixed(2)}</td>
//                 </tr>

//               </tbody>
//             </table>
//           </div>
//         </div>
//       ) : (
//         <div className="text-center p-10 bg-gray-50 rounded border">
//           No data available
//         </div>
//       )}

//       {/* DOWNLOAD BUTTON */}
//       <div className="mt-6 flex justify-end">
//         <button
//           onClick={downloadExcel}
//           className="bg-red-600 text-white px-6 py-2 rounded shadow"
//         >
//           Download Ledger
//         </button>
//       </div>
//     </div>
//   );
// };

// export default HospitalServicesLedger;

import React, { useState, useEffect } from "react";
import axiosInstance from "../../Services/axiosInstance";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const fmt = (n) => {
  const v = isNaN(n) ? 0 : Math.round(parseFloat(n) * 100) / 100;
  return v.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const HospitalServicesLedger = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showSelector, setShowSelector] = useState(false);
  const [selectedServices, setSelectedServices] = useState([]);
  const [tempSelectedServices, setTempSelectedServices] = useState([]);

  const filteredData =
    selectedServices.length === 0
      ? data
      : data.filter((item) => selectedServices.includes(item.name));

  const totals = filteredData.reduce(
    (acc, service) => {
      const purchasedPrice = parseFloat(service.purchase_price) || 0;
      const totalQtySold = Number(service.total_quantity_sold || 0);
      const totalPurchaseAmount = purchasedPrice * totalQtySold;
      const totalSaleAmount = Number(service.total_sale_amount || 0);
      const totalProfitLoss = totalSaleAmount - totalPurchaseAmount;
      acc.totalPurchaseAmount += totalPurchaseAmount;
      acc.totalQtySold += totalQtySold;
      acc.totalSaleAmount += totalSaleAmount;
      acc.totalProfitLoss += totalProfitLoss;
      return acc;
    },
    {
      totalPurchaseAmount: 0,
      totalQtySold: 0,
      totalSaleAmount: 0,
      totalProfitLoss: 0,
    },
  );

  const fetchServiceData = async (start = "", end = "") => {
    try {
      setLoading(true);
      const params = {};
      if (start) params.startDate = start;
      if (end) params.endDate = end;
      const response = await axiosInstance.get(
        "/dispenser-sales/medical-services",
        { params },
      );
      setData(response.data.data || []);
      setError(null);
    } catch (err) {
      setError("Failed to load medical services data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServiceData(startDate, endDate);
  }, [startDate, endDate]);

  const downloadExcel = () => {
    if (!filteredData || filteredData.length === 0) return;
    let totalPurchaseAmount = 0,
      totalQtySold = 0,
      totalSaleAmount = 0,
      totalProfitLoss = 0;
    const exportData = filteredData.map((item) => {
      const purchasedPrice = parseFloat(item.purchase_price) || 0;
      const totalQty = Number(item.total_quantity_sold || 0);
      const totalPurchase = purchasedPrice * totalQty;
      const totalSale = Number(item.total_sale_amount || 0);
      const profitLoss = totalSale - totalPurchase;
      totalPurchaseAmount += totalPurchase;
      totalQtySold += totalQty;
      totalSaleAmount += totalSale;
      totalProfitLoss += profitLoss;
      return {
        Name: item.name,
        PurchasedPrice: purchasedPrice.toFixed(2),
        TotalPurchaseAmount: totalPurchase.toFixed(2),
        SalePrice: parseFloat(item.price).toFixed(2),
        TotalQtySold: totalQty,
        TotalSaleAmount: totalSale.toFixed(2),
        TotalProfitLoss: profitLoss.toFixed(2),
      };
    });
    exportData.push({
      Name: "TOTAL",
      PurchasedPrice: "",
      TotalPurchaseAmount: totalPurchaseAmount.toFixed(2),
      SalePrice: "",
      TotalQtySold: totalQtySold,
      TotalSaleAmount: totalSaleAmount.toFixed(2),
      TotalProfitLoss: totalProfitLoss.toFixed(2),
    });
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services Ledger");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `HospitalServicesLedger.xlsx`);
  };

  const kpiCards = [
    {
      label: "Purchase Amount",
      value: fmt(totals.totalPurchaseAmount),
      sub: `${filteredData.length} services`,
    },
    {
      label: "Qty Sold",
      value: totals.totalQtySold,
      sub: "total units",
    },
    {
      label: "Sale Amount",
      value: fmt(totals.totalSaleAmount),
      sub: `${filteredData.length} services`,
    },
    {
      label: "Profit / Loss",
      value: fmt(totals.totalProfitLoss),
      sub: totals.totalProfitLoss >= 0 ? "net profit" : "net loss",
      accent: totals.totalProfitLoss >= 0 ? "text-green-600" : "text-red-500",
    },
  ];

  const colWidths = [
    "180px",
    "110px",
    "130px",
    "100px",
    "90px",
    "120px",
    "120px",
  ];
  const ColGroup = () => (
    <colgroup>
      {colWidths.map((w, i) => (
        <col key={i} style={{ width: w, minWidth: w }} />
      ))}
    </colgroup>
  );

  return (
    <div className="p-3 sm:p-4 font-sans">
      {/* ── Header ── */}
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <p className="text-xs font-medium tracking-widest uppercase text-gray-500">
          Hospital Services Ledger
        </p>
        <div className="flex flex-wrap items-center gap-2">
          {/* Date Filters */}
          <div className="flex items-center gap-1.5">
            <label className="text-xs text-gray-500">From</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="text-xs border border-gray-200 rounded-lg px-2.5 py-1.5 text-gray-700 bg-white focus:outline-none focus:ring-1 focus:ring-blue-100"
            />
          </div>
          <div className="flex items-center gap-1.5">
            <label className="text-xs text-gray-500">To</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="text-xs border border-gray-200 rounded-lg px-2.5 py-1.5 text-gray-700 bg-white focus:outline-none focus:ring-1 focus:ring-blue-100"
            />
          </div>
          {/* Select Services */}
          <button
            onClick={() => {
              setTempSelectedServices(selectedServices);
              setShowSelector(true);
            }}
            className="text-xs border border-gray-200 rounded-lg px-2.5 py-1.5 text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-100"
          >
            {selectedServices.length > 0
              ? `${selectedServices.length} selected`
              : "Filter Services"}
          </button>
          {/* Download */}
          <button
            onClick={downloadExcel}
            className="text-[13px] border border-gray-200 rounded-lg px-8 py-3 bg-green-500 text-white  hover:bg-green-600 focus:outline-none focus:ring-1 focus:ring-blue-100 flex items-center gap-1.5"
          >
            <svg
              className="w-3.5 h-3.5 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3"
              />
            </svg>
            Download
          </button>
        </div>
      </div>

      {/* ── KPI Cards ── */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2 sm:gap-3 mb-4">
        {kpiCards.map(({ label, value, sub, accent }) => (
          <div
            key={label}
            className="bg-gray-100 border border-gray-200 rounded-lg px-3 py-2.5"
          >
            <p className="text-[10px] tracking-wide text-gray-400 uppercase mb-1">
              {label}
            </p>
            <p
              className={`text-base font-semibold ${accent || "text-gray-800"}`}
            >
              {value}
            </p>
            <p className="text-[10px] text-gray-400 mt-0.5">{sub}</p>
          </div>
        ))}
        <div className="bg-gray-100 rounded-lg px-3 py-2.5 border-t-2 border-[#F07F1C] col-span-2 sm:col-span-3 lg:col-span-1">
          <p className="text-[10px] tracking-wide text-gray-400 uppercase mb-1">
            Records
          </p>
          <p className="text-base font-bold text-[#F07F1C]">
            {filteredData.length}
          </p>
          <p className="text-[10px] text-gray-400 mt-0.5">services shown</p>
        </div>
      </div>

      {/* ── Error ── */}
      {error && (
        <div className="mb-4 px-4 py-3 rounded-lg bg-red-50 border border-red-200 text-red-600 text-xs">
          {error}
        </div>
      )}

      {/* ══ MOBILE CARDS ══ */}
      <div className="block sm:hidden">
        {loading ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            Loading...
          </div>
        ) : filteredData.length === 0 ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            No data available
          </div>
        ) : (
          <>
            <div className="space-y-2">
              {filteredData.map((service) => {
                const purchasedPrice = parseFloat(service.purchase_price) || 0;
                const totalQtySold = Number(service.total_quantity_sold || 0);
                const totalPurchaseAmount = purchasedPrice * totalQtySold;
                const salePrice = parseFloat(service.price) || 0;
                const totalSaleAmount = Number(service.total_sale_amount || 0);
                const totalProfitLoss = totalSaleAmount - totalPurchaseAmount;
                const isProfit = totalProfitLoss >= 0;

                return (
                  <div
                    key={service.id}
                    className="border border-gray-200 rounded-xl bg-white px-3 py-3"
                  >
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-[11px] font-semibold text-gray-600 uppercase flex-shrink-0">
                          {service.name?.charAt(0) || "S"}
                        </div>
                        <p className="text-[12px] font-semibold text-gray-800">
                          {service.name}
                        </p>
                      </div>
                      <span
                        className={`text-[11px] font-semibold px-2 py-0.5 rounded-full ${
                          isProfit
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-600"
                        }`}
                      >
                        {isProfit ? "+" : ""}Rs.{fmt(totalProfitLoss)}
                      </span>
                    </div>
                    <div className="divide-y divide-gray-100">
                      {[
                        {
                          label: "Buy Price",
                          value: `Rs.${fmt(purchasedPrice)}`,
                        },
                        {
                          label: "Total Buy",
                          value: `Rs.${fmt(totalPurchaseAmount)}`,
                        },
                        { label: "Sale Price", value: `Rs.${fmt(salePrice)}` },
                        { label: "Qty Sold", value: totalQtySold },
                        {
                          label: "Total Sale",
                          value: `Rs.${fmt(totalSaleAmount)}`,
                        },
                      ].map(({ label, value }) => (
                        <div
                          key={label}
                          className="flex justify-between py-1.5"
                        >
                          <span className="text-[11px] text-gray-400 w-20">
                            {label}
                          </span>
                          <span className="text-[11px] text-gray-700 text-right">
                            {value}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Mobile Grand Total Footer */}
            <div className="mt-3 bg-[#215187] rounded-xl px-3 py-3">
              {[
                {
                  label: "Total Purchase",
                  value: `Rs.${fmt(totals.totalPurchaseAmount)}`,
                },
                { label: "Total Qty Sold", value: totals.totalQtySold },
                {
                  label: "Total Sale",
                  value: `Rs.${fmt(totals.totalSaleAmount)}`,
                },
              ].map(({ label, value }) => (
                <div
                  key={label}
                  className="flex items-center justify-between py-1.5 border-b border-white/10 last:border-0"
                >
                  <span className="text-[12px] text-gray-400">{label}</span>
                  <span className="text-[12px] text-gray-100 font-medium">
                    {value}
                  </span>
                </div>
              ))}
              <div className="flex items-center justify-between pt-2 mt-1 border-t border-white/20">
                <span className="text-[12px] font-medium text-gray-100">
                  Profit / Loss
                </span>
                <span
                  className={`text-[14px] font-bold ${
                    totals.totalProfitLoss >= 0
                      ? "text-[#F07F1C]"
                      : "text-red-400"
                  }`}
                >
                  Rs.{fmt(totals.totalProfitLoss)}
                </span>
              </div>
            </div>
          </>
        )}
      </div>

      {/* ══ DESKTOP TABLE ══ */}
      <div className="hidden sm:block border rounded-xl overflow-hidden">
        <div className="overflow-y-auto" style={{ maxHeight: "520px" }}>
          <table
            className="w-full text-sm"
            style={{
              tableLayout: "fixed",
              borderCollapse: "separate",
              borderSpacing: 0,
            }}
          >
            <ColGroup />
            <thead>
              <tr>
                {[
                  "Service Name",
                  "Buy Price",
                  "Total Purchase",
                  "Sale Price",
                  "Qty Sold",
                  "Total Sale",
                  "Profit / Loss",
                ].map((label, i) => (
                  <th
                    key={label}
                    className={`sticky top-0 z-20 bg-[#215187] text-left px-4 py-2.5 text-[11px] text-gray-100 uppercase font-medium ${
                      i < 6 ? "border-r border-white/10" : ""
                    }`}
                  >
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan={7}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    Loading...
                  </td>
                </tr>
              ) : filteredData.length === 0 ? (
                <tr>
                  <td
                    colSpan={7}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    No data available
                  </td>
                </tr>
              ) : (
                filteredData.map((service, index) => {
                  const purchasedPrice =
                    parseFloat(service.purchase_price) || 0;
                  const totalQtySold = Number(service.total_quantity_sold || 0);
                  const totalPurchaseAmount = purchasedPrice * totalQtySold;
                  const salePrice = parseFloat(service.price) || 0;
                  const totalSaleAmount = Number(
                    service.total_sale_amount || 0,
                  );
                  const totalProfitLoss = totalSaleAmount - totalPurchaseAmount;
                  const isProfit = totalProfitLoss >= 0;

                  return (
                    <tr
                      key={service.id}
                      className={`border-b border-gray-100 hover:bg-green-50 transition-colors ${
                        index % 2 ? "bg-gray-50" : "bg-white"
                      }`}
                    >
                      <td className="px-4 py-2.5 border-r border-gray-100">
                        <div className="flex items-center gap-2">
                          <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center text-[10px] font-semibold text-gray-600 uppercase flex-shrink-0">
                            {service.name?.charAt(0) || "S"}
                          </div>
                          <span className="text-[12px] font-medium text-gray-800 truncate">
                            {service.name}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                        Rs.{fmt(purchasedPrice)}
                      </td>
                      <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                        Rs.{fmt(totalPurchaseAmount)}
                      </td>
                      <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                        Rs.{fmt(salePrice)}
                      </td>
                      <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                        {totalQtySold}
                      </td>
                      <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                        Rs.{fmt(totalSaleAmount)}
                      </td>
                      <td className="px-4 py-2.5 text-[12px] font-medium">
                        <span
                          className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium ${
                            isProfit
                              ? "bg-green-100 text-green-700"
                              : "bg-red-100 text-red-600"
                          }`}
                        >
                          {isProfit ? "+" : ""}Rs.{fmt(totalProfitLoss)}
                        </span>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
            <tfoot>
              <tr className="bg-[#1F2937] text-gray-100">
                <td className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] font-medium border-r border-white/10 border-t">
                  Grand Total
                </td>
                <td className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] border-r border-white/10 border-t " />
                <td className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] border-r border-white/10 border-t ">
                  Rs.{fmt(totals.totalPurchaseAmount)}
                </td>
                <td className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] border-r border-white/10 border-t " />
                <td className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] border-r border-white/10 border-t ">
                  {totals.totalQtySold}
                </td>
                <td className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] border-r border-white/10 border-t">
                  Rs.{fmt(totals.totalSaleAmount)}
                </td>
                <td className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] font-semibold border-t border-white/10">
                  <span
                    className={
                      totals.totalProfitLoss >= 0
                        ? "text-[#F07F1C]"
                        : "text-red-400"
                    }
                  >
                    Rs.{fmt(totals.totalProfitLoss)}
                  </span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* ── Service Selector Modal ── */}
      {showSelector && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-xl w-[90%] max-w-sm overflow-hidden">
            <div className="bg-[#1F2937] px-5 py-4 flex items-center justify-between">
              <p className="text-[13px] font-semibold text-white">
                Filter Services
              </p>
              <button
                onClick={() => setShowSelector(false)}
                className="text-gray-300 hover:text-white text-xl leading-none"
              >
                &times;
              </button>
            </div>
            <div className="px-4 py-3 max-h-60 overflow-y-auto divide-y divide-gray-100">
              {data.map((item) => (
                <label
                  key={item.id}
                  className="flex items-center gap-3 py-2 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={tempSelectedServices.includes(item.name)}
                    onChange={() => {
                      setTempSelectedServices((prev) =>
                        prev.includes(item.name)
                          ? prev.filter((s) => s !== item.name)
                          : [...prev, item.name],
                      );
                    }}
                    className="accent-gray-700 w-3.5 h-3.5"
                  />
                  <span className="text-[12px] text-gray-700">{item.name}</span>
                </label>
              ))}
            </div>
            <div className="px-4 py-3 bg-gray-50 flex justify-end gap-2 border-t border-gray-100">
              <button
                onClick={() => {
                  setSelectedServices([]);
                  setShowSelector(false);
                }}
                className="text-xs px-3 py-1.5 rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-100"
              >
                Clear All
              </button>
              <button
                onClick={() => {
                  setSelectedServices(tempSelectedServices);
                  setShowSelector(false);
                }}
                className="text-xs px-3 py-1.5 rounded-lg bg-[#1F2937] text-white hover:bg-gray-700"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HospitalServicesLedger;
